// A surprise that rises out of a squeezed shell and ducks back when the hand
// lets go. The rise follows the squeeze of the soft body, so a half squeeze
// shows half a chick, and the figure turns once on the way up. Design values,
// not measurements of a real pop-out egg.
const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
export class SurpriseEgg {
  constructor({ travel = .9, turns = 1, eyesOpenAt = .85 } = {}) {
    this.travel = travel; this.turns = turns; this.eyesOpenAt = eyesOpenAt;
    this.target = 0; this.rise = 0; this.velocity = 0; this.activity = 0; this.peak = 0;
  }
  // squeeze: 0..1, how much the shell is compressed by the hand.
  squeeze(amount) { this.target = Number.isFinite(amount) ? clamp(amount, 0, 1) : 0; }
  release() { this.target = 0; }
  reset() { this.target = 0; this.rise = 0; this.velocity = 0; this.activity = 0; this.peak = 0; }
  step(dt) {
    if (!Number.isFinite(dt) || dt <= 0) return;
    dt = Math.min(dt, 1 / 30);
    // A stiff spring on the way out, a softer one on the way back, so the chick
    // pops up quickly and settles down with a small bounce.
    const rising = this.target > this.rise, omega = rising ? 26 : 16, zeta = rising ? .9 : .55;
    const steps = Math.max(1, Math.ceil(dt / (1 / 240))), h = dt / steps;
    for (let s = 0; s < steps; s++) {
      const accel = omega * omega * (this.target - this.rise) - 2 * zeta * omega * this.velocity;
      this.velocity += accel * h; this.rise += this.velocity * h;
      if (this.rise < 0) { this.rise = 0; this.velocity = Math.max(0, this.velocity); }
    }
    this.peak = Math.max(this.peak, this.rise);
    if (Math.abs(this.rise - this.target) < .0015 && Math.abs(this.velocity) < .01) { this.rise = this.target; this.velocity = 0; }
    this.activity = Math.abs(this.velocity) + Math.abs(this.target - this.rise);
    if (this.activity < 1e-4) this.activity = 0;
  }
  get eyesOpen() { return this.rise >= this.eyesOpenAt; }
  // Pose for the hidden figure: lift along the shell axis, one turn, and a
  // squash-stretch that stretches while shooting up and squashes when settling.
  pose() {
    const rise = clamp(this.rise, 0, 1.15);
    const stretch = 1 + clamp(this.velocity * .06, -.18, .25);
    return { lift: rise * this.travel, angle: rise * this.turns * Math.PI * 2, stretch, squash: 1 / Math.sqrt(stretch) };
  }
}
